export const development = {
      sharedUi: 'UI compartida',
      sampleInput: 'Valor de ejemplo',
      sampleTextarea: 'Ejemplo de campo de texto largo.',
      codePlaceholder: 'ABC-1234',

      title: 'Catálogo técnico',
      subtitle: 'Catálogo técnico interno de componentes y wrappers del sistema.',
      componentsTitle: 'Componentes',
      componentsDescription: 'Catálogo técnico unificado de componentes ordenado por estatus, con los terminados primero.',
      previewLabel: 'Ejemplo',
      primaryExample: 'Primario',
      secondaryExample: 'Secundario',
      ghostExample: 'Ghost',
      dangerExample: 'Peligro',
      iconOnlyExample: 'Ícono',
      buttonPreview: 'Variantes base del wrapper para acciones principales del sistema.',
      metricCardPreview: 'Tarjeta compacta para validar KPIs y bloques de resumen dentro del layout.',
      segmentedControlPreview: 'Control reutilizable para alternar entre dos o más vistas técnicas dentro de una pantalla.',
      showcaseCardPreview: 'Ejemplo del panel reutilizable con título, descripción, badge y zona inferior flexible.',
      formFieldPreview: 'Wrapper común para label, hint y error alrededor de un control.',
      inputPreview: 'Campo reusable conectado a formularios reactivos y ngModel.',
      selectPreview: 'Select reusable con la misma densidad visual del sistema.',
      errorMessagePreview: 'Mensaje base para validaciones y errores de formulario.',
      sidebarPreview: 'Uso actual en la navegación lateral del shell autenticado.',
      languageSwitcherPreview: 'Disponible en sidebar y login para cambio rápido de idioma.',
      paginationPreview: 'Usado en tablas administrativas con selector de página y filas por página.',
      dataTablePreview: 'Shell reutilizable para tablas administrativas con slots de acciones, contenido y paginación.',
      dataTableSampleDescription: 'Vista base para catalogar piezas shared con tabla y control de página.',
      tableCode: 'Código',
      tableComponent: 'Componente',
      tableFamily: 'Familia',
      modalPreview: 'Shell reutilizable para overlays con header, body y acciones inferiores.',
      datePickerPreview: 'Pendiente de seleccionar librería externa ligera y encapsularla.',
      modalVariantAcceptCancel: 'Aceptar / Cancelar',
      modalVariantAcceptOnly: 'Aceptar solo',
      modalVariantSaveCancel: 'Guardar / Cancelar',
      modalVariantDanger: 'Confirmar / Cancelar',
      modalAcceptCancelTitle: 'Confirmar acción',
      modalAcceptCancelSubtitle: 'Preset base para confirmaciones simples del sistema.',
      modalAcceptCancelBody: 'Usa este preset cuando el flujo requiere una confirmación simple con salida positiva y negativa.',
      modalAcceptOnlyTitle: 'Información',
      modalAcceptOnlySubtitle: 'Preset base para mensajes informativos sin acción destructiva.',
      modalAcceptOnlyBody: 'Este preset funciona para avisos o confirmaciones pasivas donde solo existe una salida principal.',
      modalSaveCancelTitle: 'Guardar cambios',
      modalSaveCancelSubtitle: 'Preset recomendado para formularios modales editables.',
      modalSaveCancelBody: 'Este preset debe usarse cuando el modal contiene un formulario y el CTA principal guarda cambios.',
      modalDangerTitle: 'Eliminar registro mock',
      modalDangerSubtitle: 'Preset para acciones sensibles o de riesgo.',
      modalDangerBody: 'Este preset deja clara la naturaleza destructiva de la acción y refuerza el CTA de cancelación.',
      sidebarTitle: 'Sidebar',
      sidebarDescription: 'Navegación lateral responsive con modo colapsado, tooltips y acceso a las áreas principales del ERP.',
      languageSwitcherTitle: 'Selector de idioma',
      languageSwitcherDescription: 'Selector de idioma reutilizable para sidebar, login y vistas compactas.',
      paginationTitle: 'Paginación de tabla',
      paginationDescription: 'Paginador compartido para tablas administrativas con selector de filas por página.',
      dataTableTitle: 'Tabla de datos',
      dataTableDescription: 'Contenedor reusable para acciones, tabla, estados vacíos y paginación en una sola pieza.',
      modalTitle: 'Modal base',
      modalDescription: 'Shell base para modales con título, subtítulo, contenido proyectado y acciones.',
      buttonTitle: 'Botón base',
      buttonDescription: 'Componente base para variantes primary, secondary, danger y estados disabled/loading.',
      metricCardTitle: 'Tarjeta metrica',
      metricCardDescription: 'Tarjeta simple para KPIs del dashboard con label, valor y tendencia.',
      metricCardSampleLabel: 'Componentes shared',
      badgeTitle: 'Badge',
      badgeDescription: 'Componente genérico para estados cortos, etiquetas y marcadores visuales reutilizables.',
      badgePreview: 'Badge base con tonos reutilizables para estados visuales del sistema.',
      badgeNeutralExample: 'Neutral',
      badgeSuccessExample: 'Éxito',
      badgeWarningExample: 'Advertencia',
      badgeDangerExample: 'Critico',
      badgeInfoExample: 'Informativo',
      listPanelTitle: 'Panel de lista',
      listPanelDescription: 'Contenedor reusable para agrupar ítems descriptivos en filas internas con acción lateral.',
      listPanelPreview: 'Panel de lista reutilizable para ajustes, catálogos o parámetros agrupados.',
      listPanelSampleTitle: 'Bloques reutilizables',
      listPanelSampleDescription: 'Agrupa accesos o configuraciones relacionadas dentro de una sola superficie.',
      listPanelRowOneTitle: 'Layout compartido',
      listPanelRowOneDescription: 'Referencia mínima para listar piezas visuales con acción lateral.',
      segmentedControlTitle: 'Control segmentado',
      segmentedControlDescription: 'Selector tipo pills para alternar vistas o estados dentro de una pantalla.',
      segmentedOptionOverview: 'General',
      segmentedOptionDetails: 'Detalle',
      showcaseCardTitle: 'Tarjeta de catálogo',
      showcaseCardDescription: 'Panel reutilizable para documentación interna, reportes visuales y catálogos con acción.',
      sampleTitle: 'Título de ejemplo',
      sampleDescription: 'Descripción breve del componente o módulo documentado.',
      formFieldTitle: 'Campo de formulario',
      formFieldDescription: 'Contenedor común para label, required, hint y mensajes de error.',
      formFieldSampleLabel: 'Correo de ejemplo',
      inputTitle: 'Input base',
      inputDescription: 'Campo base para text, email, password y number con integración a Reactive Forms.',
      selectTitle: 'Select base',
      selectDescription: 'Select estándar con la misma densidad y estados visuales del sistema.',
      textareaTitle: 'Textarea base',
      textareaDescription: 'Campo multilínea reusable para notas, observaciones y comentarios operativos.',
      textareaPreview: 'Textarea conectado al mismo lenguaje visual del sistema.',
      checkboxTitle: 'Checkbox base',
      checkboxDescription: 'Control reusable para opciones booleanas y configuraciones simples.',
      checkboxPreview: 'Checkbox base con etiqueta integrada y soporte para formularios.',
      checkboxExample: 'Enviar correo de bienvenida',
      radioGroupTitle: 'Grupo de radios',
      radioGroupDescription: 'Selector reusable para opciones mutuamente excluyentes con soporte de formularios.',
      radioGroupPreview: 'Grupo de opciones visual para elegir un solo valor dentro de un conjunto.',
      switchTitle: 'Switch base',
      switchDescription: 'Control reusable para activar o desactivar una preferencia con semántica de interruptor.',
      switchPreview: 'Switch base para configuraciones binarias y preferencias rápidas.',
      switchExample: 'Activar notificaciones operativas',
      switchExampleHint: 'Ejemplo de preferencia binaria con soporte de formulario.',
      formSectionTitle: 'Sección de formulario',
      formSectionDescription: 'Contenedor semántico para agrupar campos relacionados con título y descripción.',
      formSectionPreview: 'Sección reusable para estructurar formularios complejos en bloques claros.',
      formSectionExampleTitle: 'Datos generales',
      formSectionExampleDescription: 'Agrupa campos relacionados dentro de un mismo bloque semántico.',
      formSectionExampleHint: 'Ejemplo de ayuda contextual dentro de una sección.',
      errorMessageTitle: 'Mensaje de error',
      errorMessageDescription: 'Componente ligero para mostrar validaciones de forma consistente.',
      datePickerTitle: 'Date picker',
      datePickerDescription: 'Wrapper futuro para una librería de fechas ligera sin depender de Angular Material.',
      optionPrimary: 'Principal',
      optionPrimaryHint: 'Configuración base con mayor peso visual.',
      optionSecondary: 'Secundaria',
      optionSecondaryHint: 'Variante más sobria para acciones complementarias.',
      optionCompact: 'Compacta',
      optionCompactHint: 'Configuración pensada para espacios reducidos o toolbars.',
      statusReady: 'Listo',
      statusInUse: 'En uso',
      statusPlanned: 'Planeado',
      statusResearch: 'En evaluación',
    } as const;
